import { Routes, Route } from 'react-router-dom'
import LandingPage from './pages/LandingPage'
import AboutPage from './pages/AboutPage'
import PricingPage from './pages/PricingPage'
import PrivacyPage from './pages/PrivacyPage'
import TermsPage from './pages/TermsPage'
import CookiesPage from './pages/CookiesPage'
import ContactPage from './pages/ContactPage'
import CareersPage from './pages/CareersPage'
import SecurityPage from './pages/SecurityPage'
import SignInPage from './pages/SignInPage'
import SignUpPage from './pages/SignUpPage'
import DashboardPage from './pages/DashboardPage'
import RoleDecisionPage from './pages/RoleDecisionPage'
import { GetStartedPage } from './pages/onboarding'
import { CreateRolePage, RoleReadyPage } from './pages/roles'
import { SettingsPage, ProfilePage } from './pages/settings'

function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/cookies" element={<CookiesPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/careers" element={<CareersPage />} />
      <Route path="/security" element={<SecurityPage />} />
      <Route path="/signin" element={<SignInPage />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/get-started" element={<GetStartedPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/roles/new" element={<CreateRolePage />} />
      <Route path="/roles/new/ready" element={<RoleReadyPage />} />
      <Route path="/roles/:roleId/decision" element={<RoleDecisionPage />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/settings/profile" element={<ProfilePage />} />
      {/* Legacy route */}
      <Route path="/login" element={<SignInPage />} />
    </Routes>
  )
}

export default App

